import { useParams, Link } from 'react-router-dom';
import { getComicBySlug, getComicsByCategory } from '@/mocks/comics';

export default function ComicHero() {
  const { slug } = useParams<{ slug: string }>();
  const comic = slug ? getComicBySlug(slug) : undefined;
  const category = comic?.categorySlug;

  const latestChapter = comic ? [...comic.chapters].sort((a, b) => b.number - a.number)[0] : undefined;

  if (!comic) return null;

  return (
    <section className="relative h-screen min-h-[600px] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title}高清漫画全集免费阅读下拉式 - 178漫画网`}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/25 to-black/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4 w-full">
        <nav className="absolute top-20 left-4 md:left-6 flex items-center gap-2 text-white/70 text-xs">
          <Link to="/" className="hover:text-white transition-colors whitespace-nowrap">
            首页
          </Link>
          <span>/</span>
          {category && (
            <>
              <Link
                to={`/category/${comic.categorySlug}`}
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                {comic.category}
              </Link>
              <span>/</span>
            </>
          )}
          <span className="text-white/90">{comic.title}</span>
        </nav>

        <span className="inline-block px-3 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs font-medium border border-white/20 mb-4">
          超清画质 · 下拉式阅读 · 流畅体验
        </span>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white">
          {latestChapter ? `第${latestChapter.number}话` : comic.title}
        </h1>
        <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white/90 mt-1">
          {latestChapter?.title || ''}
        </p>

        <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            className="px-8 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm md:text-base font-medium border border-white/30 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            滚动阅读
          </button>
          <button
            type="button"
            className="px-6 py-3 rounded-full text-white text-sm md:text-base font-medium border border-white/20 hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-bookmark-line mr-1.5" />
            收藏
          </button>
        </div>
      </div>
    </section>
  );
}